module.exports = __webpack_public_path__ + "ec57e8aa218cc5aa98bf1d403e6bbae9.jpg";